<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600"
                          :href="route('attendee-import.index', [eventInfo.id])">Attendee Imports
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Auto Import
        </h1>

        <div class="flex flex-wrap">
            <div class="w-full lg:w-1/2 px-2">
                <card>
                    <div class="p-6 flex flex-wrap">
                        <div class="pb-8 w-full"><span class="font-semibold block">Source:</span>{{ attendeeAutoImport.import_source }}
                        </div>
                        <div class="pb-8 w-full"><span
                            class="font-semibold block">Form:</span>{{ attendeeAutoImport.form }}
                        </div>
                        <div class="pb-8 w-full"><span
                            class="font-semibold block">Last Import:</span>
                            {{ attendeeAutoImport.last_import ? dateFormat(attendeeAutoImport.last_import) : 'Never' }}
                        </div>
                    </div>

                    <template v-slot:footer>
                        <button v-if="can.delete" class="text-red-600 hover:underline"
                                tabindex="-1" type="button" @click="destroy">Delete Auto Import
                        </button>
                        <div class="ml-auto">
                            <form @submit.prevent="importAttendees">
                                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Import
                                </loading-button>
                            </form>
                        </div>
                    </template>
                </card>
            </div>

            <div class="w-full lg:w-1/2 px-2">
                <table-wrapper :headers="['ID', 'Time', 'Status']" :text-wrap="false" class="mb-4">
                    <table-row v-for="batch in importBatches" :key="batch.id">
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ batch.id }}</table-cell>
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ dateFormat(batch.created_at) }}</table-cell>
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ statusName(batch.status) }}</table-cell>
                        <table-cell-end :href="route('attendee-import.show', [batch.id])"></table-cell-end>
                    </table-row>

                    <table-row v-if="importBatches.length === 0">
                        <table-cell colspan="4">
                            No Import Batches Found
                        </table-cell>
                    </table-row>
                </table-wrapper>
            </div>
        </div>

    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import {DateTime} from "luxon";
import {AttendeeImportBatchStatus} from "@/Enums/Enums";
import {find} from "lodash";
import TableCellEnd from "../../Shared/Table/TableCellEnd.vue";

export default {
    metaInfo() {
        return {title: this.attendeeAutoImport.name}
    },
    components: {
        TableCellEnd,
        SelectInput,
        TextInput,
        TrashedMessage,
        LoadingButton,
        Icon,
        Card,
        CardListItem,
        TableWrapper,
        TableRow,
        TableCell
    },
    props: {
        attendeeAutoImport: Object,
        eventInfo: Object,
        importBatches: Array,
        can: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                source: 'auto',
                id: this.attendeeAutoImport.id,
            }),
        }
    },
    layout: Layout,
    methods: {
        importAttendees() {
            this.form.transform((data) => ({
                ...data,
                event_id: this.eventInfo.id,
            })).post(this.route('attendee-import.store'))
        },
        destroy() {
            if (confirm('Are you sure you want to delete this auto import?')) {
                this.$inertia.delete(this.route('attendee-auto-import.destroy', [this.attendeeAutoImport.id]))
            }
        },
        dateFormat(iso) {
            return DateTime.fromISO(iso).toFormat('dd LLL yyyy HH:mm ZZZZ')
        },
        statusName(status) {
            return find(AttendeeImportBatchStatus, ['value', status])['label']
        },
    },
}
</script>
